module.exports = __webpack_public_path__ + "static/media/Slide11.b6208327.jpg";